import { Component, Inject, OnInit, ViewChild } from "@angular/core";
import { FormGroup, Validators, FormControl } from "@angular/forms";
import { MatPaginator, PageEvent } from "@angular/material/paginator";
import { MatSort } from "@angular/material/sort";
import { MatTableDataSource } from "@angular/material/table";
import { DataSource } from "@angular/cdk/table";
import { BorrowerService } from "../borrower/borrower.service";
import { SessionService } from "../service/session.service";
import { Router, ActivatedRoute } from "@angular/router";

export interface UserData {
    id: string;
    name: string;
    email: string;
    lastLogin: Date;
}

/** Constants used to fill up our data base. */
const COLORS: string[] = [
    "maroon",
    "red",
    "orange",
    "yellow",
    "olive",
    "green",
    "purple",
    "fuchsia",
    "lime",
    "teal",
    "aqua",
    "blue",
    "navy",
    "black",
    "gray",
];
const NAMES: string[] = [
    "Maia",
    "Asher",
    "Olivia",
    "Atticus",
    "Amelia",
    "Jack",
    "Charlotte",
    "Theodore",
    "Isla",
    "Oliver",
    "Isabella",
    "Jasper",
    "Cora",
    "Levi",
    "Violet",
    "Arthur",
    "Mia",
    "Thomas",
    "Elizabeth",
];

/**
 * @title Data table with sorting, pagination, and filtering.
 */

@Component({
    selector: "app-loan-processor",
    templateUrl: "./loan-processor.component.html",
    styleUrls: ["./loan-processor.component.scss"],
})
export class LoanProcessorComponent implements OnInit {
    displayedColumns: string[] = ["id", "fname", "lname", "email", "lstLogin"];
    dataSource: MatTableDataSource<UserData>;
    mobnumPattern = "^(d{3})sd{3}-d{4}";
    add_loanProcessor = new FormGroup({
        email: new FormControl(null, [Validators.required, Validators.email,Validators.maxLength(40),Validators.minLength(5)]),
        fname: new FormControl(null, [Validators.required,Validators.maxLength(30),Validators.minLength(3)]),
        lname: new FormControl(null, [Validators.required,Validators.maxLength(30),Validators.minLength(3)]),
        // phone_no: new FormControl(null,[Validators.pattern(this.mobnumPattern), Validators.maxLength(15),Validators.minLength(8)]),
        phone_no: new FormControl(null,[]),
        statusType: new FormControl("Active", [Validators.required]),
        password: new FormControl(null, [Validators.required, Validators.maxLength(15),Validators.minLength(4)]),
        confirmPassword: new FormControl(null, [Validators.required, Validators.maxLength(15),Validators.minLength(4)]),
        country: new FormControl("us"),
        city: new FormControl(null),
        state: new FormControl(null),
        zipcode: new FormControl(null, [Validators.maxLength(10),Validators.minLength(3)]),
        address1: new FormControl(null),
        address2: new FormControl(null),
        lender: new FormControl(null, [Validators.required]),
        id: new FormControl(null),
    });

    @ViewChild(MatPaginator) paginator: MatPaginator;
    @ViewChild(MatSort) sort: MatSort;
    isList: boolean = true;
    isAdd: boolean = false;
    isEdit: boolean = false;
    submitted: boolean = false;
    favoriteSeason: string;
    userDetail: any = {};
    userList: any = {};
    loading = false;
    formattedaddress = "";
    options = {
        componentRestrictions: {
            country: ["US"],
        },
    };
    lender_list: any = {};
    status: any = ["Blocked", "Active"];
    maskPhoneFormat: any = '(000) 000-0000';

    constructor(
        private _bservice: BorrowerService,
        private sessionService: SessionService,
        @Inject(Router) private router: Router,
        @Inject(ActivatedRoute) private route: ActivatedRoute
    ) {}

    ngOnInit() {
        if (this.sessionService.get("userInfo") != undefined) {
            this.userDetail = JSON.parse(this.sessionService.get("userInfo"));
        }
        this.GetUserList();
        this.GetLenderUserList();
    }

    keyDownPhoneFormat($event) {
        var key = $event.keyCode;

        if (key == 91 || (15 < key && key < 19) || (37 <= key && key <= 40)) {
            return;
        }
        this.changePhoneFormat($event);
    }

    changePhoneFormat($event) {
        var getVal = $event.target.value;
        var tel = getVal.replace(/[^0-9]/g, "");
        $event.target.value = this.changeFilter(tel);
    }
    changeFilter(tel) {
        if (!tel) {
            return "";
        }

        var value = tel.toString().trim().replace(/^\+/, "");

        if (value.match(/[^0-9]/)) {
            return tel;
        }

        var country, city, number;

        switch (value.length) {
            case 1:
            case 2:
            case 3:
                city = value;
                break;

            default:
                city = value.slice(0, 3);
                number = value.slice(3);
        }

        if (number) {
            if (number.length > 3) {
                number = number.slice(0, 3) + "-" + number.slice(3, 7);
            } else {
                number = number;
            }

            return ("(" + city + ") " + number).trim();
        } else {
            return "(" + city;
        }
    }

    public AddressChange(address: any) {
        let addressFielsLength = address.address_components.length;
        let address1 = "";
        let city = "";
        let state = "";
        let zipcode = "";

        for (let i = 0; i < addressFielsLength; i++) {
            if (address.address_components[i].types[0] == "street_number") {
                address1 = address.address_components[i].long_name;
            }

            if (address.address_components[i].types[0] == "route") {
                address1 =
                    address1 + " " + address.address_components[i].long_name;
            }

            if (
                address.address_components[i].types[0] ==
                    "sublocality_level_1" ||
                address.address_components[i].types[0] == "locality" ||
                address.address_components[i].types[0] == "neighborhood"
            ) {
                city = address.address_components[i].long_name;
            }
            if (
                address.address_components[i].types[0] ==
                "administrative_area_level_1"
            ) {
                state = address.address_components[i].short_name;
            }
            if (address.address_components[i].types[0] == "postal_code") {
                zipcode = address.address_components[i].long_name;
            }
        }

        this.add_loanProcessor.controls["address1"].setValue(address1);
        this.add_loanProcessor.controls["city"].setValue(city);
        this.add_loanProcessor.controls["state"].setValue(state);
        this.add_loanProcessor.controls["zipcode"].setValue(zipcode);
    }
    applyFilter(filterValue) {
        const target = filterValue as HTMLInputElement;
        const targetValue = target.value;
        this.dataSource.filter = targetValue.trim().toLowerCase();

        if (this.dataSource.paginator) {
            this.dataSource.paginator.firstPage();
        }
    }

    showAddForm() {
        this.isAdd = true;
        this.isList = false;
    }

    loanProcessorList() {
        this.isEdit = false;
        this.isList = true;
    }

    ValidatePartnerPass() {
        let password = this.add_loanProcessor.controls.password.value;
        let repeatPassword =
            this.add_loanProcessor.controls.confirmPassword.value;

        if (repeatPassword !== password) {
            this.add_loanProcessor.controls["confirmPassword"].setErrors({
                incorrect: true,
            });
        } else {
            this.add_loanProcessor.controls["confirmPassword"].setErrors(null);
        }
    }
    SaveRecord() {
        if (this.add_loanProcessor.invalid) {
            return;
        } else {
            this.submitted = false;
            var formData = this.add_loanProcessor.value;

            if (formData.id == null && !this.isEdit) {
                this.loading = true;
                var data = {
                    EmailId: formData.email,
                    Password: formData.password,
                    UserType: this.sessionService.userType[5].Value,
                    FirstName: formData.fname,
                    LastName: formData.lname,
                    Status: formData.statusType,
                    Phone: formData.phone_no,
                    Address1: formData.address1,
                    Addresss2: formData.address2,
                    City: formData.city,
                    State: formData.state,
                    Zip: formData.zipcode,
                    Country: formData.country,
                    CreatedBy: this.userDetail.EmailId,
                    LenderId: formData.lender,
                };
                this._bservice.AddBorrower(data).subscribe(
                    (response) => {
                        this.sessionService.notifier.notify(
                            "success",
                            "Loan Processor added successfully."
                        );
                        this.isList = true;
                        this.isAdd = false;
                        this.GetUserList();
                        this.loading = false;
                        window.scrollTo(0, 0);
                    },
                    (error) => {
                        this.sessionService.notifier.notify(
                            "error",
                            error.error.message
                        );
                        this.loading = false;
                    }
                );
            } else {
                this.loading = true;
                var data1 = {
                    EmailId: formData.email,
                    Password: formData.password,
                    UserType: this.sessionService.userType[5].Value,
                    FirstName: formData.fname,
                    LastName: formData.lname,
                    Status: formData.statusType,
                    Phone: formData.phone_no,
                    Address1: formData.address1,
                    Addresss2: formData.address2,
                    City: formData.city,
                    State: formData.state,
                    Zip: formData.zipcode,
                    Country: formData.country,
                    CreatedBy: this.userDetail.EmailId,
                    LenderId: formData.lender,
                    Id: formData.id,
                };
                this._bservice.UpdateBorrower(data1).subscribe(
                    (response) => {
                        this.sessionService.notifier.notify(
                            "success",
                            "Loan Processor updated successfully."
                        );

                        this.isList = true;
                        this.isAdd = false;
                        this.isEdit = false;
                        this.formReset();
                        this.GetUserList();
                        this.loading = false;
                        window.scrollTo(0, 0);
                    },
                    (error) => {
                        this.sessionService.notifier.notify(
                            "error",
                            error.error.message
                        );
                        this.loading = false;
                    }
                );
            }
        }
    }

    nextPage(event: PageEvent) {}

    GetUserList() {
        this.loading = true;
        var data = {
            EmailId: "",
            PageSize: 100000,
            LastEvaluatedKey: 0,
            UserType: this.sessionService.userType[5].Value,
        };
        this._bservice.GetUserList(data).subscribe(
            (response) => {
                if (response != null) {
                    this.userList = response;
                    this.userList.Items.sort(function (a, b) {
                        return a.Id < b.Id ? 1 : -1;
                    });
                    const users = Array.from(
                        { length: this.userList.Count },
                        (_, k) => createNewUser(k, this.userList)
                    );
                    this.dataSource = new MatTableDataSource(users);
                    this.dataSource.paginator = this.paginator;

                    this.loading = false;
                }
            },
            (error) => {}
        );
    }

    GetLenderUserList() {
        this.loading = true;
        var data = {
            EmailId: "",
            PageSize: 100000,
            LastEvaluatedKey: 0,
            UserType: this.sessionService.userType[4].Value,
        };
        this._bservice.GetLenderList(data).subscribe(
            (response) => {
                if (response != null) {
                    response.Items.sort(function (a, b) {
                        if (
                            a.Name.trim().toLowerCase() <
                            b.Name.trim().toLowerCase()
                        ) {
                            return -1;
                        }
                        if (
                            a.Name.trim().toLowerCase() >
                            b.Name.trim().toLowerCase()
                        ) {
                            return 1;
                        }
                        return 0;
                    });
                    this.lender_list = response.Items;

                    this.loading = false;
                }
            },
            (error) => {}
        );
    }

    deleteUser(userid) {
        if (confirm("Are you sure to delete Loan Processor")) {
            this._bservice.DeleteUser(userid).subscribe(
                (response) => {
                    this.sessionService.notifier.notify(
                        "success",
                        "Loan Processor deleted successfully."
                    );

                    this.isList = true;
                    this.isAdd = false;
                    this.isEdit = false;
                    this.formReset();
                    this.GetUserList();
                    this.loading = false;
                },
                (error) => {
                    this.sessionService.notifier.notify(
                        "error",
                        error.error.message
                    );
                    this.loading = false;
                }
            );
            window.scroll(0, 0);
        }
    }

    EditUser(item) {
        this.isEdit = true;
        this.isList = false;

        this.add_loanProcessor.setValue({
            email: item.EmailId,
            fname: item.FirstName,
            lname: item.LastName,
            phone_no: item.Phone == undefined ? null : item.Phone,
            statusType: item.Status,

            password: item.Password,
            confirmPassword: item.Password,
            id: item.Id,
            lender: item.LenderId == undefined ? "" : item.LenderId,
            country: item.Country == undefined ? "" : item.Country,
            city: item.City,
            state: item.State,
            zipcode: item.Zip,
            address2: item.Addresss2 == undefined ? "" : item.Addresss2,
            address1: item.Address1,
        });
    }

    formReset() {
        this.add_loanProcessor.reset();
        this.add_loanProcessor.controls["statusType"].setValue("Active");
    }
}

/** Builds and returns a new User. */
function createNewUser(id: number, userList): UserData {
    const name =
        NAMES[Math.round(Math.random() * (NAMES.length - 1))] +
        " " +
        NAMES[Math.round(Math.random() * (NAMES.length - 1))].charAt(0) +
        ".";
    if (userList.Items[id] != undefined) {
        userList.Items[id].id = id + 1;
        return userList.Items[id];
    }
}
